const { Carousel, MatchMedia } = window.Project;

// 作り込みINDEXの、スマホの時だけ表示されるタグボタンカルーセルのクラス。
class TagCarouselClass {
  carousel?: InstanceType<typeof Carousel>;

  init() {
    MatchMedia.addListener(['smo'], () => {
      this.carousel = new Carousel('.tagCarousel_container');
      this.carousel.init({
        spaceBetween: 10,
        slidesPerView: 'auto',
        freeMode: true,
      });
    });

    MatchMedia.addListener(['md'], () => {
      if (this.carousel) {
        this.carousel.destroy();
        this.carousel = undefined;
      }
    });
  }

  update() {
    if (this.carousel) {
      this.carousel.swiper?.update();
    }
  }
}

export const TagCarousel = new TagCarouselClass();
